/*
 * @@Description: 共享方法
 * @@Author: MuYang
 * @Date: 2021-09-13 10:51:34
 * @LastEditTime: 2021-09-13 11:00:54
 */
import { hasClass } from '../../../../../../utils/dom'

export const MODE_TYPES = {
  WAIT: 'WAIT', //等待
  SHOW: 'SHOW', // 显示
  DOWN: 'DOWN', // 按下
  SHOW_DOWN: 'SHOW_DOWN' // 显示并且按下
}

// 当前模式
export let MODE = ''

export const changeMode = val => (MODE = val)

// 当前可视区域
export const getCurClient = () => ({
  height: document.documentElement.clientHeight,
  width: document.documentElement.clientWidth
})

// 是否是dom
export function isDom (dom) {
  return typeof HTMLElement === 'object'
    ? dom instanceof HTMLElement
    : dom &&
        typeof dom === 'object' &&
        dom.nodeType === 1 &&
        typeof dom.nodeName === 'string'
}

// 获取指定祖节点
export function getReferNode (curEl, refer) {
  if (!isDom(curEl)) {
    throw new Error('params error: el is required')
  }
  if (!refer) {
    return curEl
  }
  let targetNode = curEl
  while (true) {
    if (hasClass(targetNode, refer)) {
      break
    }
    if (targetNode.tagName === 'BODY') {
      break
    }
    targetNode = targetNode.parentNode
  }
  return targetNode
}
